// =========================
// JS — Upsell popup + i18n
// =========================
(function () {
  const popup = document.getElementById('UpsellPopup');

    /* =========================
     Fullscreen image viewer
     ========================= */
  const viewer = popup.querySelector('.imgViewer');
  const viewerImg = popup.querySelector('.imgViewer__img');
  const viewerCloseEls = popup.querySelectorAll('[data-imgviewer-close]');

  function openImageViewer(src, alt) {
    if (!viewer || !viewerImg || !src) return;
    viewerImg.src = src;
    viewerImg.alt = alt || '';
    viewer.classList.add('is-open');
    viewer.setAttribute('aria-hidden', 'false');
    // prevent background scroll (keep upsell already locked, but safe)
    document.body.style.overflow = 'hidden';
  }

  function closeImageViewer() {
    if (!viewer || !viewerImg) return;
    viewer.classList.remove('is-open');
    viewer.setAttribute('aria-hidden', 'true');
    viewerImg.removeAttribute('src');
    viewerImg.alt = '';
    // restore scroll lock state based on upsell open/closed
    document.body.style.overflow = popup.classList.contains('is-open') ? 'hidden' : '';
  }

  viewerCloseEls.forEach(el => el.addEventListener('click', closeImageViewer));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && viewer?.classList.contains('is-open')) {
      closeImageViewer();
    }
  });

  // Delegate click on any upsell image (sac / ecrin / organza)
  popup.addEventListener('click', (e) => {
    // if viewer open, don't re-trigger
    if (viewer?.classList.contains('is-open')) return;

    const img = e.target.closest('.uCard__media img');
    if (!img) return;

    // Use the clicked image source; if you're hovering and click, it opens that exact one
    const src = img.currentSrc || img.src;
    const alt = img.alt || img.getAttribute('alt') || '';

    if (src) openImageViewer(src, alt);
  });



  if (!popup) return;

  /* =========================
     i18n (FR / NL / EN)
     Language detected by URL:
     - /nl => nl
     - /en => en
     - default => fr
     ========================= */
  const UPSELL_I18N = {
    fr: {
      title: "VOTRE EMBALLAGE CADEAU VENIZI",
      left_title: "Emballages cadeau",
      left_title_2: "(optionnel)",
      left_sub_1: "Parfait pour offrir",
      left_sub_2: "Chaque emballage est soigneusement adapté au bijou choisi",
      right_title: "Bourse organza",
      right_sub: "(offerte) avec chaque bijou",
      add: "Ajouter",
      added: "Ajouté ✓",
      continue: "Continuez les achats",
      view_cart: "Afficher mon panier",
      close: "Fermer",
      ecrin_not_found: "Écrin (non trouvé)"
    },
    nl: {
      title: "UW VENIZI CADEAUVEREPAKKING",
      left_title: "Cadeauverpakkingen",
      left_title_2: "(optioneel)",
      left_sub_1: "Perfect om cadeau te geven",
      left_sub_2: "Elke verpakking wordt zorgvuldig afgestemd op het gekozen juweel",
      right_title: "Organza zakje",
      right_sub: "(gratis) bij elk juweel",
      add: "Toevoegen",
      added: "Toegevoegd ✓",
      continue: "Verder winkelen",
      view_cart: "Mijn winkelmand bekijken",
      close: "Sluiten",
      ecrin_not_found: "Doosje (niet gevonden)"
    },
    en: {
      title: "YOUR VENIZI GIFT PACKAGING",
      left_title: "Gift packaging",
      left_title_2: "(optional)",
      left_sub_1: "Perfect for gifting",
      left_sub_2: "Each package is carefully adapted to the chosen jewelry",
      right_title: "Organza pouch",
      right_sub: "(free) with every piece of jewelry",
      add: "Add",
      added: "Added ✓",
      continue: "Continue shopping",
      view_cart: "View cart",
      close: "Close",
      ecrin_not_found: "Box (not found)"
    }
  };

  function getLangFromUrl() {
    const p = window.location.pathname || "/";
    if (p.startsWith("/nl")) return "nl";
    if (p.startsWith("/en")) return "en";
    return "fr";
  }

  const LANG = getLangFromUrl();
  const T = UPSELL_I18N[LANG] || UPSELL_I18N.fr;

  /* =========================
   Continue shopping redirect (FR / NL)
   ========================= */
  /* =========================
   Continue shopping redirect (FR / NL) — NO close delay
   Intercepts click BEFORE data-upsell-close handler
   ========================= */
  const continueBtn = popup.querySelector('.upsell__footerBtn[data-i18n="continue"]');

  if (continueBtn) {
    continueBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation?.();

      const url =
        (LANG === 'nl')
          ? 'https://www.venizi.com/nl/collections/all'
          : (LANG === 'en')
            ? 'https://www.venizi.com/en/collections/all?sort_by=price-descending&filter.v.price.gte=&filter.v.price.lte='
          : 'https://www.venizi.com/collections/all?sort_by=price-descending&filter.v.price.gte=&filter.v.price.lte=';

      window.location.assign(url);
    }, true); // ✅ capture = true (runs before your close listener)
  }

  /* =========================
     Écrin title translation
     ========================= */
  const ECRIN_TRANSLATIONS = {
    nl: {
      earrings: "Luxe doosje voor oorbellen",
      ring: "Luxe doosje voor ringen",
      necklace: "Luxe doosje voor kettingen",
      bracelet: "Luxe doosje voor armbanden",
      watch: "Luxe doosje voor uurwerken",
      generic: "Luxe juwelendoosje"
    },
    en: {
      earrings: "Luxury box for earrings",
      ring: "Luxury ring box",
      necklace: "Luxury box for necklaces",
      bracelet: "Luxury box for bracelets",
      watch: "Luxury box for watches",
      generic: "Luxury jewelry box"
    }
  };

  function normalizeText(value) {
    return (value || "")
      .toString()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  }

  function detectEcrinCategory(title) {
    const normalized = normalizeText(title);
    if (!normalized) return null;

    if (
      normalized.includes("boucles d'oreilles") ||
      normalized.includes("boucles doreilles") ||
      normalized.includes("oreille") ||
      normalized.includes("earring")
    ) return "earrings";

    if (normalized.includes("bague") || normalized.includes("ring")) return "ring";

    if (
      normalized.includes("montre") ||
      normalized.includes("watch") ||
      normalized.includes("horloge")
    ) return "watch";

    if (normalized.includes("bracelet") || normalized.includes("bangle")) return "bracelet";

    if (
      normalized.includes("collier") ||
      normalized.includes("necklace") ||
      normalized.includes("parure") ||
      normalized.includes("pendentif") ||
      normalized.includes("pendant")
    ) return "necklace";

    return "generic";
  }

  function translateEcrinTitle(title) {
    if (LANG === "fr") return title;

    const translations = ECRIN_TRANSLATIONS[LANG];
    if (!title || !translations) return title;

    const category = detectEcrinCategory(title);
    return (category && translations[category]) ? translations[category] : title;
  }

  // Apply static translations (data-i18n attributes)
  popup.querySelectorAll("[data-i18n]").forEach((el) => {
    const key = el.getAttribute("data-i18n");
    if (key && T[key]) el.textContent = T[key];
  });

  // Close button aria label
  const closeBtn = popup.querySelector(".upsell__close");
  if (closeBtn) closeBtn.setAttribute("aria-label", T.close);

  /* =========================
     Your existing logic
     ========================= */

  // ✅ Correct Sac VARIANT ID
  const VARIANT_SAC = 55993229574521;

  // Images
  const SAC_IMAGE_1 =
    "https://cdn.shopify.com/s/files/1/0941/0615/7433/files/SACPM_GM.png?v=1763385560";
  const SAC_IMAGE_2 =
    "https://cdn.shopify.com/s/files/1/0941/0615/7433/files/grandsac.png?v=1763385560";
  const ORGANZA_IMAGE =
    "https://cdn.shopify.com/s/files/1/0941/0615/7433/files/bourse.jpg?v=1770211047";

  // Display
  const SAC_TITLE =
    (LANG === "nl") ? "Venizi cadeauzak" :
    (LANG === "en") ? "Venizi gift bag" :
    "Sac cadeau Venizi";

  const ORGANZA_TITLE =
    (LANG === "nl") ? "Organza zakje" :
    (LANG === "en") ? "Organza pouch" :
    "Bourse organza";

  const SAC_PRICE_CENTS = 150;

  const closeEls = popup.querySelectorAll('[data-upsell-close]');

  const openPopup = () => {
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };

  const closePopup = () => {

    if (viewer?.classList.contains('is-open')) closeImageViewer();


    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  closeEls.forEach((el) => el.addEventListener('click', closePopup));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closePopup();
  });

  const money = (cents) => {
    const currency = (window.Shopify?.currency?.active) ? Shopify.currency.active : 'EUR';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency })
        .format((cents || 0) / 100);
    } catch {
      return ((cents || 0) / 100).toFixed(2) + ' ' + currency;
    }
  };

  async function addVariantToCart(variantId, qty = 1) {
    const endpoint =
      (window.routes && window.routes.cart_add_url)
        ? window.routes.cart_add_url
        : '/cart/add';

    const fd = new FormData();
    fd.append('id', String(variantId));
    fd.append('quantity', String(qty));

    const res = await fetch(`${endpoint}.js`, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: fd,
      credentials: 'same-origin'
    });

    if (!res.ok) {
      let err;
      try { err = await res.json(); } catch (_) {}
      console.error('Shopify /cart/add.js error:', err || res.status);
      throw new Error(err?.description || err?.message || 'Erreur ajout panier');
    }

    return res.json();
  }

  async function fetchComplementaryProducts(productId) {
    const url = `/recommendations/products.json?product_id=${encodeURIComponent(productId)}&intent=complementary&limit=10`;
    const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
    if (!res.ok) return null;
    return res.json();
  }

  function getEcrinCache(productId) {
    try {
      const data = sessionStorage.getItem(`ecrin_${productId}`);
      return data ? JSON.parse(data) : null;
    } catch {
      return null;
    }
  }

  function setEcrinCache(productId, ecrin) {
    try {
      sessionStorage.setItem(`ecrin_${productId}`, JSON.stringify(ecrin));
    } catch {}
  }

  const ECRIN_BY_PRODUCT_ID = {
    15231035375993: '295',
    15231035408761: '295',
    15231035441529: '295'
  };

  function guessEcrinHandle(added) {
    if (ECRIN_BY_PRODUCT_ID[added.product_id]) return ECRIN_BY_PRODUCT_ID[added.product_id];

    const kind = normalizeText([
      added?.product_type,
      added?.title,
      added?.handle
    ].join(' '));

    if (kind.includes('boucle') || kind.includes('earring') || kind.includes('oreille')) return '295';
    return '296';
  }

  async function searchEcrinFallback(handle = '296') {
    try {
      const prodRes = await fetch(`/products/${handle}.json`, {
        headers: { Accept: 'application/json' }
      });

      if (!prodRes.ok) {
        console.warn('[Upsell] Fallback: could not fetch', handle);
        return null;
      }

      const prodData = await prodRes.json();
      return buildEcrinData(prodData?.product);
    } catch (err) {
      console.error('[Upsell] searchEcrinFallback error:', err);
      return null;
    }
  }

  function getImageUrl(image) {
    if (!image) return '';
    if (typeof image === 'string') return image;
    if (typeof image === 'object') return image.src || image.url || '';
    return '';
  }

  function pickFirstAvailableVariant(product) {
    const variants = product?.variants || [];
    return variants.find((variant) => variant.available) || variants[0] || null;
  }

  function isLikelyEcrinProduct(product) {
    const haystack = [
      product?.title,
      product?.handle,
      product?.product_type,
      product?.type,
      product?.vendor,
      Array.isArray(product?.tags) ? product.tags.join(' ') : ''
    ].join(' ');

    const text = normalizeText(haystack);
    return text.includes('ecrin') ||
      text.includes('coffret') ||
      text.includes('jewelry box') ||
      text.includes('gift box') ||
      text.includes('box') ||
      text.includes('doos');
  }

  function buildEcrinData(product) {
    if (!product) return null;

    const variant = pickFirstAvailableVariant(product);
    if (!variant) return null;

    const rawPrice = variant.price;
    const priceCents =
      typeof rawPrice === 'number'
        ? rawPrice
        : (rawPrice !== null && rawPrice !== undefined && rawPrice !== '' ? Math.round(parseFloat(rawPrice) * 100) : null);

    return {
      title: translateEcrinTitle(product.title),
      price_cents: priceCents,
      image: getImageUrl(product.featured_image) || getImageUrl(product.image) || getImageUrl(product.images?.[0]),
      image2: getImageUrl(product.images?.[1]),
      variant_id: variant.id
    };
  }

  function pickEcrinFromRecommendations(recJson) {
    const products = recJson?.products || [];
    const ecrin = products.find((product) => isLikelyEcrinProduct(product));
    return buildEcrinData(ecrin);
  }

  function fillCard(slot, data) {
    const card = popup.querySelector(`.uCard[data-slot="${slot}"]`);
    if (!card) return;

    const nameEl = card.querySelector('[data-name]');
    const priceEl = card.querySelector('[data-price]');
    const imgEl1 = card.querySelector('[data-img]');
    const imgEl2 = card.querySelector('[data-img2]');
    const media = card.querySelector('.uMedia');
    const addBtn = card.querySelector('[data-add]');

    if (nameEl) nameEl.textContent = data.title || '';
    if (priceEl) {
      priceEl.textContent =
        (data.price_cents === null || data.price_cents === undefined)
          ? ''
          : money(data.price_cents);
    }

    if (imgEl1) {
      if (data.image) {
        imgEl1.src = data.image;
        imgEl1.alt = data.title || '';
      } else {
        imgEl1.removeAttribute('src');
        imgEl1.alt = '';
      }
    }

    if (imgEl2) {
      if (data.image2) {
        imgEl2.src = data.image2;
        imgEl2.alt = data.title ? `${data.title} (alt)` : '';
        media?.classList.add('has-hover');
      } else {
        imgEl2.removeAttribute('src');
        imgEl2.alt = '';
        media?.classList.remove('has-hover');
      }
    }

    if (addBtn) {
      if (data.variant_id) {
        addBtn.disabled = false;
        addBtn.textContent = T.add;
        addBtn.setAttribute('data-upsell-add', String(data.variant_id));
      } else {
        addBtn.disabled = true;
        addBtn.removeAttribute('data-upsell-add');
      }
    }
  }

  // Click "Ajouter" inside popup
  popup.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-upsell-add]');
    if (!btn) return;

    const variantId = btn.getAttribute('data-upsell-add');
    btn.disabled = true;
    const originalText = btn.textContent;

    try {
      await addVariantToCart(variantId, 1);
      btn.textContent = T.added;
    } catch (err) {
      console.error(err);
      btn.disabled = false;
      btn.textContent = err?.message ? err.message : 'Erreur';
      setTimeout(() => { btn.textContent = originalText; }, 2500);
    }
  });

  // Hook add-to-cart forms (prevents redirect)
  const forms = document.querySelectorAll('form[action*="/cart/add"]');
  forms.forEach((form) => {
    if (form.dataset.upsellBound === 'true') return;
    form.dataset.upsellBound = 'true';

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation?.();

      const fd = new FormData(form);
      fd.delete('return_to');
      fd.delete('checkout');

      const endpoint =
        (window.routes && window.routes.cart_add_url)
          ? window.routes.cart_add_url
          : '/cart/add';

      try {
        // Add main product
        const res = await fetch(`${endpoint}.js`, {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: fd,
          credentials: 'same-origin'
        });
        if (!res.ok) throw new Error('add to cart failed');
        const added = await res.json();

        // Sac (fixed)
        fillCard('p1', {
          title: SAC_TITLE,
          price_cents: SAC_PRICE_CENTS,
          image: SAC_IMAGE_1,
          image2: SAC_IMAGE_2,
          variant_id: VARIANT_SAC
        });

        // Organza (included)
        fillCard('p3', {
          title: ORGANZA_TITLE,
          price_cents: null,
          image: ORGANZA_IMAGE,
          image2: "",
          variant_id: null
        });

        // Fetch complementary -> pick ecrin
        const recJson = await fetchComplementaryProducts(added.product_id);
        let ecrin = pickEcrinFromRecommendations(recJson);

        if (ecrin) {
          setEcrinCache(added.product_id, ecrin);
          fillCard('p2', ecrin);
        } else {
          ecrin = getEcrinCache(added.product_id);

          if (!ecrin) {
            await new Promise((resolve) => setTimeout(resolve, 500));
            const recJsonRetry = await fetchComplementaryProducts(added.product_id);
            ecrin = pickEcrinFromRecommendations(recJsonRetry);
          }

          if (!ecrin) {
            ecrin = await searchEcrinFallback(guessEcrinHandle(added));
          }

          if (ecrin) {
            setEcrinCache(added.product_id, ecrin);
            fillCard('p2', ecrin);
          } else {
            fillCard('p2', {
              title: T.ecrin_not_found,
              price_cents: null,
              image: "",
              image2: "",
              variant_id: null
            });
          }
        }

        openPopup();
      } catch (err) {
        console.error(err);
      }
    }, true);
  });
})();
